import * as THREE from 'three'
import { MathUtils } from 'three'
import { useEffect, useRef, useState } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { OrbitControls } from '@react-three/drei'
import * as Tone from 'tone'
import inst from "./inst"
import { Instances, Instance } from '@react-three/drei'
import anime from 'animejs/lib/anime.es.js';

let isMobile = window.innerWidth < 500

let hit = 0;

let lerp = MathUtils.lerp

let getRand = (arr) => arr[Math.floor(Math.random() * arr.length)]
let allNotes = ["C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "A2", "B2", "C3", "E3", "A3", "B3", "C4", "E4", "A4", "B4", "C5", "E5", "A5", "B5", "C6", "E6", "A6", "E6", "C6", "B5", "A5", "E5", "C5", "B4", "A4", "E4", "C4", "B3", "A3", "E3", "C3", "B2", "C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "A2", "B2", "C3", "E3", "A3", "B3", "C4", "E4", "A4", "B4", "C5", "E5", "A5", "B5", "C6", "E6", "A6", "E6", "C6", "B5", "A5", "E5", "C5", "B4", "A4", "E4", "C4", "B3", "A3", "E3", "C3", "B2", "A2", "C3", "F3", "G3", "A3", "C4", "F4", "G4", "A4", "C5", "F5", "G5", "A5", "C6", "F6", "G6", "A6", "G6", "F6", "C6", "A5", "G5", "F5", "C5", "A4", "G4", "F4", "C4", "A3", "G3", "F3", "C3", "B2", "D3", "G3", "A3", "B3", "D4", "G4", "A4", "B4", "D5", "G5", "A5", "B5", "D6", "G6", "A6", "B6", "A6", "G6", "D6", "B5", "A5", "G5", "D5", "B4", "A4", "G4", "D4", "B3", "A3", "G3", "D3", "G#2", "C3", "D#3", "G3", "G#3", "C4", "D#4", "G4", "G#4", "C5", "D#5", "G5", "G#5", "C6", "D#6", "G6", "G#6", "G6", "D#6", "C6", "G#5", "G5", "D#5", "C5", "G#4", "G4", "D#4", "C4", "G#3", "G3", "D#3", "C3", "A#2", "D3", "F3", "A3", "A#3", "D4", "F4", "A4", "A#4", "D5", "F5", "A5", "A#5", "D6", "F6", "A6", "A#6", "A6", "F6", "D6", "A#5", "A5", "F5", "D5", "A#4", "A4", "F4", "D4", "A#3", "A3", "F3", "D3", "C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "A2", "B2", "C3", "E3", "A3", "B3", "C4", "E4", "A4", "B4", "C5", "E5", "A5", "B5", "C6", "E6", "A6", "E6", "C6", "B5", "A5", "E5", "C5", "B4", "A4", "E4", "C4", "B3", "A3", "E3", "C3", "B2", "C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "A2", "B2", "C3", "E3", "A3", "B3", "C4", "E4", "A4", "B4", "C5", "E5", "A5", "B5", "C6", "E6", "A6", "E6", "C6", "B5", "A5", "E5", "C5", "B4", "A4", "E4", "C4", "B3", "A3", "E3", "C3", "B2", "A2", "C3", "F3", "G3", "A3", "C4", "F4", "G4", "A4", "C5", "F5", "G5", "A5", "C6", "F6", "G6", "A6", "G6", "F6", "C6", "A5", "G5", "F5", "C5", "A4", "G4", "F4", "C4", "A3", "G3", "F3", "C3", "B2", "D3", "G3", "A3", "B3", "D4", "G4", "A4", "B4", "D5", "G5", "A5", "B5", "D6", "G6", "A6", "B6", "A6", "G6", "D6", "B5", "A5", "G5", "D5", "B4", "A4", "G4", "D4", "B3", "A3", "G3", "D3", "G#2", "C3", "D#3", "G3", "G#3", "C4", "D#4", "G4", "G#4", "C5", "D#5", "G5", "G#5", "C6", "D#6", "G6", "G#6", "G6", "D#6", "C6", "G#5", "G5", "D#5", "C5", "G#4", "G4", "D#4", "C4", "G#3", "G3", "D#3", "C3", "A#2", "D3", "F3", "A3", "A#3", "D4", "F4", "A4", "A#4", "D5", "F5", "A5", "A#5", "D6", "F6", "A6", "A#6", "A6", "F6", "D6", "A#5", "A5", "F5", "D5", "A#4", "A4", "F4", "D4", "A#3", "A3", "F3", "D3", "C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "A2", "B2", "C3", "E3", "A3", "B3", "C4", "E4", "A4", "B4", "C5", "E5", "A5", "B5", "C6", "E6", "A6", "E6", "C6", "B5", "A5", "E5", "C5", "B4", "A4", "E4", "C4", "B3", "A3", "E3", "C3", "B2", "C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "A2", "B2", "C3", "E3", "A3", "B3", "C4", "E4", "A4", "B4", "C5", "E5", "A5", "B5", "C6", "E6", "A6", "E6", "C6", "B5", "A5", "E5", "C5", "B4", "A4", "E4", "C4", "B3", "A3", "E3", "C3", "B2", "A2", "C3", "F3", "G3", "A3", "C4", "F4", "G4", "A4", "C5", "F5", "G5", "A5", "C6", "F6", "G6", "A6", "G6", "F6", "C6", "A5", "G5", "F5", "C5", "A4", "G4", "F4", "C4", "A3", "G3", "F3", "C3", "B2", "D3", "G3", "A3", "B3", "D4", "G4", "A4", "B4", "D5", "G5", "A5", "B5", "D6", "G6", "A6", "B6", "A6", "G6", "D6", "B5", "A5", "G5", "D5", "B4", "A4", "G4", "D4", "B3", "A3", "G3", "D3", "G#2", "C3", "D#3", "G3", "G#3", "C4", "D#4", "G4", "G#4", "C5", "D#5", "G5", "G#5", "C6", "D#6", "G6", "G#6", "G6", "D#6", "C6", "G#5", "G5", "D#5", "C5", "G#4", "G4", "D#4", "C4", "G#3", "G3", "D#3", "C3", "A#2", "D3", "F3", "A3", "A#3", "D4", "F4", "A4", "A#4", "D5", "F5", "A5", "A#5", "D6", "F6", "A6", "A#6", "A6", "F6", "D6", "A#5", "A5", "F5", "D5", "A#4", "A4", "F4", "D4", "A#3", "A3", "F3", "D3", "C3", "D3", "E3", "G3", "C4", "D4", "E4", "G4", "C5", "D5", "E5", "G5", "C6", "D6", "E6", "G6", "C7", "G6", "E6", "D6", "C6", "G5", "E5", "D5", "C5", "G4", "E4", "D4", "C4", "G3", "E3", "D3", "G#2", "C3", "D3", "F3", "G#3", "C4", "D4", "F4", "G#4", "C5", "D5", "F5", "G#5", "C6", "D6", "F6", "G2", "C3", "D3", "F3", "G3", "C4", "D4", "F4", "G4", "C5", "D5", "F5", "G5", "C6", "D6", "G6"]
let durs = [0.1]
let octaveOffset = 1;
let offsets = [0]

function Sequence({ updated, length, ready, index, y = 4000, space = 1, width = 0.2, height = 0.05, pull, max, min, ...props }) {
  const all = useRef()
  let time = 0;
  let dur = 0
  let durMult = getRand([2])
  let s = 0.005 +(Math.random()*0.005)
  let scaleMult = 1 + (Math.random() * 0.01)
  let totRot = getRand([1,2]) *Math.PI
  let data = Array.from({ length: length }, (v, i) => {
    let note = allNotes[i];
    let frac = (i / length)
    let rot = frac * totRot
    let size = s
    let half = size * length * 0.5
    let pos = {
      x: half - (i * size),
      y: 0,
      z: 0
    }
    dur = getRand(durs) * durMult;
    let pretime = time
    time = time + dur
    let velocity = 0.1 + (Math.random() * dur * 2)
    let scale = 1
    return { time: pretime, note, i, pos, dur, currPos: { x: 0, y: 0, z: 0 }, velocity, scale, currRot: 0, rot, currScale: 1 + (i * scaleMult), durMult }
  });
  let currTime = 0;

  let loopEnd = time
  let reversing = getRand([false])
  let scaleAdd = 0.5 + (Math.random()*1.8)
  let hold = 0.05 + (Math.random()*0.5)
  const part = new Tone.Part(((time, val) => {
    hit++;
    let s1 = inst.synthL
    let s2 = inst.synthR
    if (!val.i && reversing) {
      mut.reverse = !mut.reverse
    }
    let currI = val.i
    s1.triggerAttackRelease(allNotes[hit % allNotes.length], val.dur*hold, time, val.velocity);
    s2.triggerAttackRelease(allNotes[hit % allNotes.length], val.dur*hold, time, val.velocity);
    data[currI].scale = 1+scaleAdd
    anime({
      targets: data[currI],
      scale: 1,
      duration: loopEnd * 1000
    })
  }), data);

  useEffect(() => {
    if (ready) {
      part.start();
    }
    return () => part.stop()
  }, [ready, updated])
  part.loop = true;
  part.loopStart = 0;
  part.loopEnd = loopEnd;
  useFrame((state) => {
    if (all && all.current) {
      all.current.children.map((child,i) => {
        child.rotation.set(0, 0, mut.rot)
        let lerped = lerp(child.position.x, (i * gapX) - half,0.04)
        child.position.set(lerped, 0, 0)
      })
    }
    //ref.current.rotation.set(0,ref.current.rotation.y + (rewind ? spinSpeed : -spinSpeed),0)
  })
  let sphere = new THREE.SphereBufferGeometry(width * 0.2, 16, 16)
  sphere.scale(3.5, 1, 1)
  let sphere2 = new THREE.SphereBufferGeometry(width * 0.4, 16, 16)
  let rad = 0.015
  let cylinder = new THREE.CylinderBufferGeometry(width * rad, width * rad, 20, 64, 64)
  let rad2 = 0.5
  let circle = new THREE.CylinderBufferGeometry(width * rad2, width * rad2, 0.005, 2, 2)
  let box = new THREE.BoxBufferGeometry(width * rad2 * 1.2, width * rad2 * 1.2, 0.01)
  let torus = new THREE.TorusBufferGeometry(width * rad2, width * rad2 * 0.1, 3, 3)



  circle.rotateZ(Math.PI * 0.5)
  circle.rotateX(Math.PI * 0.5)
  box.rotateZ(Math.PI * 0.5)
  box.rotateY(Math.PI * 0.5)

  torus.rotateZ(Math.PI * 0.5)
  torus.rotateY(Math.PI * 0.5)

  let geo = getRand([circle])
  let len = isMobile ? 7 : 9
  let gapX = 0.11+ (0.2 *Math.random())
  let half = gapX * (len - 1) * 0.5
  //  const matcap = useLoader(THREE.TextureLoader, './C7C7D7_4C4E5A_818393_6C6C74-512px.png')
  let col = getRand(['#FF7722', 'MediumSeaGreen', '#21AAFF', '#3EB489'])
  col = "#fff"
  let scale = (j) => j % 2 ? 1 : 1
  let modRand = 0.1 + Math.random()
  let posRand = Math.random()
  let rotation = (j) => j % 2 ? 0 : 0
  let yPosMod = (j) => (j % 2 ? s*length*0.5 : -s*length*0.5) * modRand
  let yPos = (k) => k * s*length
  const material = new THREE.MeshStandardMaterial({
    color: '#fff',
  })
  let rowAmt = Math.floor(Math.random()*8)

  return (
    <group ref={all} position={[0,-0.75,0]}>
      {new Array(len).fill().map((v, j) => (
        <group scale={[scale(j), scale(j), scale(j)]}>
          {new Array(4).fill().map((v, k) => (
            <Instances {...props} key={k} limit={2000} geometry={geo} material={material} position={[0, (length == 16 ? length*0.02 : length == 32 ? length*0.0 : 0 ) + yPos(k+1) + yPosMod(j), 0]} rotation={[0, 0, rotation(j) + (Math.PI * 0.5)]} >
              {data.map((curr, i) => (
                <>
                  <Note key={1} gapX={gapX} i={i} j={j} data={data} size={0.1} space={0} speed={0.05} pull={pull} min={min} scale={4} />
                </>
              ))}
            </Instances>
          ))}
          <mesh geometry={cylinder} material={material} rotation={[0, 0, Math.PI]}>
          </mesh>
        </group>
      ))}
    </group>
  )
}


function Note({ i, j, size, data, pull, min, scale, speed, gapX }) {
  const ref = useRef()
  useFrame((state) => {
    let t = state.clock.getElapsedTime()
    let lerpScale = lerp(
      data[i].currScale,
      (data[i].scale) * scale + gapX*j,
      speed * (0.1*(i+1)))
    data[i].currScale = lerpScale;

    ref.current.scale.set(1,lerpScale * size * mut.zoom2,1)
    let p = pull * 0.02

    let x = data[i].currPos.x = lerp(
      data[i].currPos.x,
      data[i].pos.x,
      speed)

    let y = data[i].currPos.y = lerp(
      data[i].currPos.y,
      data[i].pos.y,
      speed) * (mut.zoom)

    ref.current.position.set(
      x * mut.zoom,
      y * mut.zoom,
      data[i].pos.z * mut.zoom
    )

    let rot = data[i].currRot = lerp(
      data[i].currRot,
      data[i].rot + (lerpScale * Math.PI * 0.1),
      speed * 0.01)

    ref.current.rotation.set(
      rot,
      0,
      0,
    )
  })
  return (
    <>
      <Instance ref={ref} />
    </>
  )
}
let canSpawn = true;
let mut = { zoom: 1, zoom2: 1, rot: getRand([1, -1]) * Math.random() * 0.5, rot2: 0, rot3: 0, reverse: true };
let easing = 'easeInQuart'
let easing2 = 'easeOutQuart'
let easing3 = 'easeInOutQuart'
let duration = 600
let first = false
let rewind = false

export default function App() {
  const cam = useRef()

  const [ready, set] = useState(false)
  const [updated, setUpdated] = useState(false)
  const click = () => {
    Tone.Transport.start();
    Tone.context.resume();
    if (canSpawn) {
      anime({
        targets: mut,
        zoom: 10,
        zoom2: 0,
        duration: duration * 0.5,
        easing,
      })
      setTimeout(() => {
        setUpdated(!updated)
        set(true)
        canSpawn = false
        rewind = Math.random() > 0.5 ? true : false
        octaveOffset = getRand(offsets)
        setTimeout(() => {
          anime({
            targets: mut,
            zoom: 1,
            zoom2: 1,
            duration,
            easing: easing2,
          })
        }, 50)
        let dTime = 0.1 * Math.floor((Math.random() * 5))
        let dTime2 = 0.1 * Math.floor((Math.random() * 5))
        let rTime = 0.5 + Math.random() * 1
        let rTime2 = 0.5 + Math.random() * 1
        inst.delayL.delayTime.linearRampToValueAtTime(0.1 + dTime, rTime)
        inst.delayR.delayTime.linearRampToValueAtTime(0.1 + dTime2, rTime2)
        canSpawn = true
        mut.reverse = !mut.reverse
      }, duration + 100)
      let val = 2500;
      let time = (duration) / 1000;
      inst.filterL.frequency.rampTo(val, time * 0.5);
      inst.filterR.frequency.rampTo(val, time * 0.5)
      setTimeout(() => {
        inst.filterL.frequency.rampTo(inst.defaultFreq, time);
        inst.filterR.frequency.rampTo(inst.defaultFreq, time)

      }, time * 1000)
      let newRot = getRand([1, -1]) * Math.random() * 0.3
      let doRot = Math.abs(mut.rot - newRot) < 0.2 ? -mut.rot : newRot
      anime({
        targets: mut,
        rot: doRot,
        duration: duration,
        easing: easing3
      })

    }
  }
  return (
    <div className="fullscreen" onMouseDown={() => { click() }}>
      <Canvas dpr={[1, 2]} camera={{ position: [0, -0.1, isMobile ? 4 : 3.5], fov: 55 }}>
        <OrbitControls ref={cam} autoRotate autoRotateSpeed={0} />
        <ambientLight intensity={0.75} />
        <color attach="background" args={['#000']} />
        <pointLight position={[30, -2, -50]} intensity={20} color={"#FF7722"} />
        <pointLight position={[-30, -4, 5]} intensity={60} color={"MediumSeaGreen"} />
        <Sequence updated={updated} index={1} ready={ready} length={getRand([2,3,4])*8} pull={(Math.random() * 1.5) - 0.75} min={(Math.random() * getRand([0.3, 0.5, 1.5])) + 0.02} />
      </Canvas>
    </div>
  )
}

console.log('%c🌱🌱 @ramioso 2021-10-24 🌱🌱 ', 'color: orange');